import React from 'react'
import './App.css';
import { Link } from 'react-router-dom';

export default function HomeScreen() {
  return (
    <div className="home-screen">
      <div className="main-card">
        <div className="logo-placeholder">
          <img src="/Logo.png" alt="ActivoLog Logo" className="logo-image" />
        </div>
        <h1>ActivoLog – Status Tracker</h1>
        <p>Welcome to your stunning new React application</p>
        <Link to="/privacy_policy" className="main-button">
          Privacy Policy
        </Link>
      </div>
    </div>
  )
}

